export default __webpack_public_path__ + "static/media/checkCircle.0a0f1564.svg";